// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Venues page */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.add-btn {
  background: #5865f2;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.add-btn:hover {
  background: #4752c4;
}

.filter-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.filter-tabs button {
  background: #2f3136;
  color: #b9bbbe;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.filter-tabs button.active,
.filter-tabs button:hover {
  background: #5865f2;
  color: white;
}

.venues-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.venue-card {
  background: #2f3136;
  border-radius: 8px;
  padding: 15px;
  border-left: 4px solid #5865f2;
  transition: transform 0.2s, box-shadow 0.2s;
}

.venue-card:hover {
  transform: translateX(3px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.venue-card.favorite {
  border-left-color: #faa61a;
}

.venue-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.venue-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.venue-name {
  color: #fff;
  margin: 0;
  font-size: 16px;
}

.type-badge {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: bold;
}

.type-badge.club { background: #5865f2; color: white; }
.type-badge.bar { background: #faa61a; color: black; }
.type-badge.cafe { background: #43b581; color: white; }
.type-badge.restaurant { background: #f04747; color: white; }
.type-badge.venue { background: #9b59b6; color: white; }
.type-badge.other { background: #72767d; color: white; }

.favorite-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #72767d;
  padding: 4px;
}

.favorite-btn .starred {
  color: #faa61a;
}

.venue-location {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #b9bbbe;
  font-size: 13px;
  margin-bottom: 8px;
}

.venue-desc {
  color: #dcddde;
  font-size: 13px;
  margin: 0 0 8px 0;
}

.venue-schedule {
  color: #72767d;
  font-size: 12px;
  margin-bottom: 8px;
}

.venue-schedule .schedule-label {
  color: #b9bbbe;
  font-weight: bold;
}

.venue-meta {
  display: flex;
  gap: 15px;
  font-size: 12px;
  color: #72767d;
  margin-bottom: 10px;
}

.venue-meta .visit-count {
  color: #43b581;
}

.venue-meta .venue-link {
  color: #5865f2;
  text-decoration: none;
}

.venue-meta .venue-link:hover {
  text-decoration: underline;
}

.venue-actions {
  display: flex;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid #40444b;
}

.action-btn {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
}

.action-btn.visit {
  background: #43b581;
  color: white;
}

.action-btn.visit:hover {
  background: #3aa070;
}

.action-btn.edit {
  background: #5865f2;
  color: white;
}

.action-btn.edit:hover {
  background: #4752c4;
}

.action-btn.delete {
  background: #f04747;
  color: white;
}

.action-btn.delete:hover {
  background: #d83c3c;
}

.no-venues {
  text-align: center;
  color: #72767d;
  padding: 40px;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #36393f;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal h2 {
  color: #fff;
  margin: 0 0 20px 0;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  color: #b9bbbe;
  margin-bottom: 5px;
  font-size: 13px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #40444b;
  border-radius: 4px;
  background: #2f3136;
  color: #fff;
  font-size: 14px;
}

.form-group textarea {
  min-height: 80px;
  resize: vertical;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  padding: 10px 20px;
  background: #40444b;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn {
  padding: 10px 20px;
  background: #5865f2;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn:hover {
  background: #4752c4;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #40444b;
  border-top-color: #5865f2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Venues.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA,mBAAmB,mBAAmB,EAAE,YAAY,EAAE;AACtD,kBAAkB,mBAAmB,EAAE,YAAY,EAAE;AACrD,mBAAmB,mBAAmB,EAAE,YAAY,EAAE;AACtD,yBAAyB,mBAAmB,EAAE,YAAY,EAAE;AAC5D,oBAAoB,mBAAmB,EAAE,YAAY,EAAE;AACvD,oBAAoB,mBAAmB,EAAE,YAAY,EAAE;;AAEvD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* Venues page */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.add-btn {\n  background: #5865f2;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.add-btn:hover {\n  background: #4752c4;\n}\n\n.filter-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.filter-tabs button {\n  background: #2f3136;\n  color: #b9bbbe;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.filter-tabs button.active,\n.filter-tabs button:hover {\n  background: #5865f2;\n  color: white;\n}\n\n.venues-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.venue-card {\n  background: #2f3136;\n  border-radius: 8px;\n  padding: 15px;\n  border-left: 4px solid #5865f2;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.venue-card:hover {\n  transform: translateX(3px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.venue-card.favorite {\n  border-left-color: #faa61a;\n}\n\n.venue-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 8px;\n}\n\n.venue-title-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.venue-name {\n  color: #fff;\n  margin: 0;\n  font-size: 16px;\n}\n\n.type-badge {\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n.type-badge.club { background: #5865f2; color: white; }\n.type-badge.bar { background: #faa61a; color: black; }\n.type-badge.cafe { background: #43b581; color: white; }\n.type-badge.restaurant { background: #f04747; color: white; }\n.type-badge.venue { background: #9b59b6; color: white; }\n.type-badge.other { background: #72767d; color: white; }\n\n.favorite-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  color: #72767d;\n  padding: 4px;\n}\n\n.favorite-btn .starred {\n  color: #faa61a;\n}\n\n.venue-location {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #b9bbbe;\n  font-size: 13px;\n  margin-bottom: 8px;\n}\n\n.venue-desc {\n  color: #dcddde;\n  font-size: 13px;\n  margin: 0 0 8px 0;\n}\n\n.venue-schedule {\n  color: #72767d;\n  font-size: 12px;\n  margin-bottom: 8px;\n}\n\n.venue-schedule .schedule-label {\n  color: #b9bbbe;\n  font-weight: bold;\n}\n\n.venue-meta {\n  display: flex;\n  gap: 15px;\n  font-size: 12px;\n  color: #72767d;\n  margin-bottom: 10px;\n}\n\n.venue-meta .visit-count {\n  color: #43b581;\n}\n\n.venue-meta .venue-link {\n  color: #5865f2;\n  text-decoration: none;\n}\n\n.venue-meta .venue-link:hover {\n  text-decoration: underline;\n}\n\n.venue-actions {\n  display: flex;\n  gap: 8px;\n  padding-top: 10px;\n  border-top: 1px solid #40444b;\n}\n\n.action-btn {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n}\n\n.action-btn.visit {\n  background: #43b581;\n  color: white;\n}\n\n.action-btn.visit:hover {\n  background: #3aa070;\n}\n\n.action-btn.edit {\n  background: #5865f2;\n  color: white;\n}\n\n.action-btn.edit:hover {\n  background: #4752c4;\n}\n\n.action-btn.delete {\n  background: #f04747;\n  color: white;\n}\n\n.action-btn.delete:hover {\n  background: #d83c3c;\n}\n\n.no-venues {\n  text-align: center;\n  color: #72767d;\n  padding: 40px;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: #36393f;\n  border-radius: 8px;\n  padding: 20px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal h2 {\n  color: #fff;\n  margin: 0 0 20px 0;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  color: #b9bbbe;\n  margin-bottom: 5px;\n  font-size: 13px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #40444b;\n  border-radius: 4px;\n  background: #2f3136;\n  color: #fff;\n  font-size: 14px;\n}\n\n.form-group textarea {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.cancel-btn {\n  padding: 10px 20px;\n  background: #40444b;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn {\n  padding: 10px 20px;\n  background: #5865f2;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn:hover {\n  background: #4752c4;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  padding: 40px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #40444b;\n  border-top-color: #5865f2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
